import { render } from "./FlightMulitItem.vue?vue&type=template&id=adb6b43a"
import script from "./FlightMulitItem.vue?vue&type=script&lang=js"
export * from "./FlightMulitItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__